/**
 * SessionStore Utility.
 *
 * Abstracts common sessionStorage operations.
 *
 */
import BaseStore from './storebase';

/**
 * SessionStorage Utility class.
 */
export default class SessionStore extends BaseStore {

    /**
     * Check if session storage is possible by setting an indicator value.
    */
    public checkAvailability(): void {
        this.set(`${this.prefix}-ct-ses-test`, ['1']);
    }

    /**
     * Passively get the sessionStorage object located at key.
     * Handles if sessionStorage is not available by returning false
     * (for failure).
     *
     * @param {string} key
     * @return {StoreGetResult}
     */
    public get(key: string) : Array<string> {
        if (this.status) {
            try {
                let value = window.sessionStorage.getItem(key);
                if (value) {
                    return JSON.parse(value);
                }
            } catch (error) {
                this.fail(error);
                return [];
            }
        }
        return [];
    }

    /**
     * Passively set the sessionStorage object located at key with value.
     * Handles if sessionStorage is not available by returning false.
     *
     * @param {string} key
     * @param {string | object} value
     * @return {StoreSetResult}
     */
    public set(key: string, value: Array<string>): boolean {
        if (this.status) {
            const jsonValue = JSON.stringify(value);
            try {
                window.sessionStorage.setItem(key, jsonValue);
                // ensure was set properly
                if (JSON.stringify(this.get(key)) !== jsonValue) {
                    return false;
                }
                return true;
            } catch (error) {
                return this.fail(error);
            }
        }
        return false;
    }

}
